import { memo } from "react";
import { cn } from "@/lib/utils";
import { FloorPlanFixture, FixtureType } from "@/types/fixture";
import { Wine, Store, ArrowUpDown, DoorOpen, TreeDeciduous, Square, Minus, Circle as CircleIcon } from "lucide-react";

const ICONS: Record<FixtureType, any> = {
  rectangle: Square,
  circle: CircleIcon,
  wall: Minus,
  bar: Wine,
  counter: Store,
  stairs: ArrowUpDown,
  door: DoorOpen,
  plant: TreeDeciduous,
};

interface Props {
  fixture: FloorPlanFixture & { pos_x_px?: number | null; pos_y_px?: number | null; width_px?: number | null; height_px?: number | null };
  isSelected?: boolean;
  isInteractive?: boolean;
}

export const V2Fixture = memo(({ fixture, isSelected, isInteractive }: Props) => {
  const Icon = ICONS[fixture.type] || Square;
  const x = (fixture as any).pos_x_px ?? fixture.x * 80;
  const y = (fixture as any).pos_y_px ?? fixture.y * 80;
  const w = (fixture as any).width_px ?? fixture.width * 80;
  const h = (fixture as any).height_px ?? fixture.height * 80;
  const isCircle = fixture.type === 'circle';

  return (
    <div
      data-v2-fixture-id={fixture.id}
      className={cn(
        "absolute flex items-center justify-center text-white/90 select-none border",
        isCircle ? "rounded-full" : "rounded",
        isSelected && "ring-2 ring-primary",
        !isInteractive && "pointer-events-none",
      )}
      style={{
        left: x, top: y, width: w, height: h,
        background: fixture.color || '#6b7280',
        opacity: 0.85,
        transform: fixture.rotation ? `rotate(${fixture.rotation}deg)` : undefined,
      }}
      title={fixture.name || fixture.type}
    >
      <Icon className="w-4 h-4 opacity-80" />
    </div>
  );
});
V2Fixture.displayName = 'V2Fixture';
